import Errors from '../../utils/Errors';

const validateReload = (giftCardNumber) => {
    let errors = new Errors();
    errors = errors.clearAll();
    if(giftCardNumber === null || giftCardNumber.length === 0) {
      errors = errors.addError('giftCardNumber', 'error.gift-card-number-required');
    }

    if(errors.hasError('giftCardNumber')) {
      return Promise.reject(errors);
    }
    return Promise.resolve();
};

export default validateReload;
